module.exports = __webpack_public_path__ + "static/img/question6-3.2d8410b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question6-3.png
// module id = Y2m7
// module chunks = 1